import React from 'react';
import { process } from "@progress/kendo-data-query";
import { Layout } from '../components/MasterPage/Layout';
import { DocumentGrid } from '../components/Grid/DocumentGrid';
import { DocumentSeachBox } from '../components/DocumentSearchBox';
import useFetchWithMsal from '../services/useFetchWithMsal';
import { cookieHandler } from "../services/cookieHandler";
import { SearchData } from "../Data/SearchData";
import { apiRoutes } from '../services/apiRoutes';
import { LoadingPanel } from '../components/LoadingPanel';

export function Home(props) {
	const { getCookie } = cookieHandler();

	let documentGridSettingsJSON = getCookie("SpheraSearchType");
	let searchTypetemp = "1";
	if (documentGridSettingsJSON != null && documentGridSettingsJSON !== "") {
		searchTypetemp = documentGridSettingsJSON;
	}

	const urlParams = new URLSearchParams(window.location.search);
	let sArch = urlParams.get('searchArchive');
	if (sArch == null || !props.currentTenent.IsViewArchivedDocumentsUser)
		sArch = false;

	const { execute, result } = useFetchWithMsal({
		scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
	});

	const { GetSearchData, getLanguageOptions, getCorrectLocalization } = SearchData({ execute, localizations: props.localizations, customer: props.customer, languageValue: props.languageValue });

	const [preSearch, setpreSearch] = React.useState(true);
	const [searchArchive, setsearchArchive] = React.useState(sArch); 
	const [searchType, setsearchType] = React.useState(searchTypetemp); 
	const [searchPhrase, setsearchPhrase] = React.useState("");
	const [searchPhraseNoWildcard, setsearchPhraseNoWildcard] = React.useState("");
	const [searchedPhrase, setsearchedPhrase] = React.useState("");
	const [searchInvalid, setsearchInvalid] = React.useState(false);
	const [documents, setdocuments] = React.useState([]);
	const [dataState, setDataState] = React.useState({ skip: 0, take: 25 });
	const [pending, setPending] = React.useState(false);
	const [languageFilterLoaded, setlanguageFilterLoaded] = React.useState(false);
	const [localesSelected, setlocalesSelected] = React.useState([]);
	const [localesDropdownData, setlocalesDropdownData] = React.useState([]);
	const [filteredLocales, setfilteredLocales] = React.useState([]);
	const[dataResult, setDataResult] = React.useState(
		process(documents, dataState)
		);
	const dataStateChange = (event) => {
		setDataResult(process(documents, event.dataState));
		setDataState(event.dataState);
	};

	const handleLocalesDropdownChange = (e) => {
		let newlocalesDropdownData = localesDropdownData;
		newlocalesDropdownData.forEach(x => {
			x.show = false;
		});
		e.forEach(x => {
			let phrase = newlocalesDropdownData.find(y => x.value === y.value);
			if (phrase)
				phrase.show = true;
		});

		let locales = e;
		setlocalesSelected(locales);
		setlocalesDropdownData(newlocalesDropdownData);
		setfilteredLocales(newlocalesDropdownData);
	};

	const changeLanguage = () => {
		let newDocs = documents;
		newDocs = newDocs.map(x => {
			x.materialName = getCorrectLocalization(x.synonyms, props.languageValue.languageCode, false);
			x.manufacturer = getCorrectLocalization(x.synonyms, props.languageValue.languageCode, true) ?? x.manufacturer;
			return x;
		});

		setdocuments(newDocs);
		setDataResult(process(newDocs, dataState));
	}

	const [gotData, setgotData] = React.useState(false);
	React.useEffect(() => {
		if ((props.localizations.Search == null || gotData) && execute != null)
			return;
		setgotData(true);
	}, [execute, props.localizations]);

	React.useEffect(() => { changeLanguage(); }, [props.localizations]);

	React.useEffect(() => {
		if (gotData) {
			const urlParams = new URLSearchParams(window.location.search);
			let searchPhrase = urlParams.get('search');
			if (searchPhrase != null) {
				setsearchPhrase(searchPhrase);
				setsearchPhraseNoWildcard(searchPhrase.replaceAll("?", "").replaceAll("*", ""));
				setsearchedPhrase(searchPhrase);
				SubmitSearch(execute, searchPhrase, searchPhrase.replaceAll("?", "").replaceAll("*", ""), localStorage.getItem("languages"), sArch);
			}


			getLanguageOptions().then((result) => {
				setlocalesDropdownData(result.json);
				setlocalesSelected(result.values);
				setfilteredLocales(result.json);
			});
		}
	}, [gotData]);

	React.useEffect(() => {
		if (!languageFilterLoaded && localesDropdownData.length > 0 && props.currentTenent) {
			if (props.currentTenent.UserSearchMaterialFilter && props.currentTenent.UserSearchMaterialFilter.LanguagesIds && props.currentTenent.UserSearchMaterialFilter.LanguagesIds.length != 0)
			{
				let newdata = localesDropdownData.filter(x => props.currentTenent.UserSearchMaterialFilter.LanguagesIds.filter(y => y == x.value).length != 0);
				setlocalesDropdownData(newdata);
				setfilteredLocales(newdata);
				if (localStorage.getItem("languages")) {
					let ids = localStorage.getItem("languages").split(",");
					let values = newdata.filter(x => ids.filter(y => y == x.languageId).length > 0);
					setlocalesSelected(values);
				}
			}
			setlanguageFilterLoaded(true);
		}
	}, [props.currentTenent, localesDropdownData]);

	const SubmitSearch = (execute, searchPhraseCookie, searchPhraseNoWildcardCookie, languageValues, searchArch) => {
		// Validate the same value GetSearchData does (cookie/URL value takes precedence over state, which may not be set yet).
		let noWildcardCheck = searchPhraseNoWildcard;
		if (searchPhraseNoWildcardCookie != null)
			noWildcardCheck = searchPhraseNoWildcardCookie;
		if (noWildcardCheck == null || noWildcardCheck.length < 3) {
			// Invalid/empty search: show the "at least 3 characters" message and stay on the pre-search view.
			setsearchInvalid(true);
			return;
		}
		setsearchInvalid(false);
		setpreSearch(false);
		setPending(true);

		GetSearchData(searchArchive, searchPhrase, searchPhraseNoWildcard, localesSelected, searchPhraseCookie, searchPhraseNoWildcardCookie, languageValues, searchType, searchArch).then((results) => {
			// GetSearchData returns undefined for an empty/under-3-char search; bail out so the spinner clears instead of hanging.
			if (!results) {
				setPending(false);
				return;
			}
			setdocuments(results.documents);
			setDataResult(process(results.documents, { skip: 0, take: 25 }));
			setDataState({ skip: 0, take: 25 });
			setPending(false);
			setsearchedPhrase(results.searchPhraseVal);
		}).catch(() => setPending(false));
	}

	const [showExportInfo, setShowExportInfo] = React.useState(false);
	const [exportInfoMsg, setExportInfoMsg] = React.useState("");

	// The customer-configured material columns the grid is showing (field + display title, in order).
	const buildExportColumns = () => {
		const cols = (props.customer.columns && props.customer.columns.materialColumns) || [];
		return cols.filter(c => c.show).map(c => ({ field: c.field, title: c.Title || c.field }));
	};

	// Stream the complete material result set (server-capped) as CSV, mirroring the current search criteria.
	const exportSearch = async () => {
		if (result == null) return;
		if (searchPhraseNoWildcard == null || searchPhraseNoWildcard.length < 3) {
			setExportInfoMsg(props.localizations.SearchNotValidText || "Please enter at least 3 characters.");
			setShowExportInfo(true);
			return;
		}
		const exportColumns = buildExportColumns();
		if (exportColumns.length === 0) return;
		try {
			setPending(true);
			const langs = localStorage.getItem("languages") || "";
			const culture = props.languageValue ? props.languageValue.languageCode : "";
			const cols = encodeURIComponent(JSON.stringify(exportColumns));
			let url = `${apiRoutes.materials.searchExport}?searchPhrase=${encodeURI(searchPhrase)}&phrase=${searchType === "2"}&languageIds=${langs}${searchArchive ? "&searchArchive=true" : ""}&culture=${encodeURIComponent(culture)}&columns=${cols}`;
			const response = await fetch(url, { method: "GET", headers: { Authorization: `Bearer ${result.accessToken}` } });
			if (!response.ok) {
				console.log(`Export failed: ${response.status}`);
				return;
			}
			const blob = await response.blob();
			const objectUrl = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = objectUrl;
			a.download = "material-search.csv";
			document.body.appendChild(a);
			a.click();
			a.remove();
			window.URL.revokeObjectURL(objectUrl);

			if (response.headers.get("X-Export-Truncated") === "true") {
				const max = parseInt(response.headers.get("X-Export-Max-Rows") || "0", 10);
				const template = props.localizations.MaterialExportLimitMessage || "Export limited to {0} rows; refine your search for the remainder.";
				setExportInfoMsg(template.replace("{0}", max.toLocaleString()));
				setShowExportInfo(true);
			}
		} catch (err) {
			console.log(err);
		} finally {
			setPending(false);
		}
	};

	const buttonsConfig = [
		{
			type: 'secondary',
			icon: 'icon-ui-general-download',
			tooltip: props.localizations.Download,
			position: "top",
			onClick: exportSearch
		}
	];

	return (
		<Layout searchArchive={searchArchive} versionNumber={props.versionNumber} currentTenent={props.currentTenent} localizations={props.localizations} changeLanguage={changeLanguage} languageValue={props.languageValue}
			buttonsConfig={buttonsConfig} info={showExportInfo} setInfo={setShowExportInfo} infoMessage={exportInfoMsg}>
			<DocumentSeachBox currentTenent={props.currentTenent} searchPhraseNoWildcard={searchPhraseNoWildcard} setsearchPhraseNoWildcard={setsearchPhraseNoWildcard}
				loginConfig={props.loginConfig} setsearchType={setsearchType} searchType={searchType} localizations={props.localizations}
				SubmitSearch={SubmitSearch} setsearchPhrase={setsearchPhrase} searchPhrase={searchPhrase} preSearch={preSearch} searchArchive={searchArchive} setsearchArchive={setsearchArchive}
				searchInvalid={searchInvalid} setsearchInvalid={setsearchInvalid}
				localesSelected={localesSelected} handleLocalesDropdownChange={handleLocalesDropdownChange} localesDropdownData={localesDropdownData} filteredLocales={filteredLocales} setfilteredLocales={setfilteredLocales} ></DocumentSeachBox>
			{!preSearch && gotData && <DocumentGrid
				searchedPhrase={searchedPhrase}
				customer={props.customer}
				dateFormatId={props.customer.DateFormatId}
				pending={pending}
				localizations={props.localizations}
				documents={documents}
				dataState={dataState}
				dataResult={dataResult}
				dataStateChange={dataStateChange}
				currentTenent={props.currentTenent}
				searchArchive={searchArchive}
			>
			</DocumentGrid>}
			{pending && (preSearch || !gotData) && <LoadingPanel localizations={props.localizations} />}
		</Layout>
	);
}
